module.exports = __webpack_public_path__ + "img/ai2.00a0ff88.png";